import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';

interface IProps {
  tableColumns?;
  inventoryList?: any;
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?;
}

const InventoryListView = ({
  tableColumns,
  inventoryList,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: IProps) => {
  return (
    <Table
      columns={tableColumns}
      data={inventoryList}
      name={TableNames.INVENTORY_LIST}
      alternating={false}
      headerLines={2}
      footerLines={1}
      borderBottom={true}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default InventoryListView;
